import { Checks, Copy, WarningCircle, X } from "@phosphor-icons/react";
import React from "react";
import dayjs from "dayjs"; // Use for date/time formatting
import { formatHotel } from "../../api/hotelTime";
import PromoBreakdown from "../Dashboard/PromoBreakdown";
 
const PrePostCabModal = ({requestData,setRequestType,setOpenRequestModal,setRequestData}) => {
  
    // Format the date and time
    const tripDate = formatHotel(requestData.time_of_arrival, "DD MMMM YYYY");
    const tripTime = formatHotel(requestData.time_of_arrival, "hh:mm A");


    // Close Modal
    const closeModal=()=>{
        try{
            setOpenRequestModal(false);
            setRequestType("");
            setRequestData(null);
            
        }catch(error){
            console.log(error);
        }
    }

    // console.log("Data of Cab : ",requestData);

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
           
            <div
                className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]">
                
                {/*  Request Header */}
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold">Cab To Hotel</h2>
                    <button
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                        onClick={()=>closeModal()}
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                <div className="flex flex-col gap-4">

                    {/* Room Details */}
                    <div className="flex items-center justify-between">
                 
                        <div className="w-1/3">
                            <p className="text-[#8C9199] mb-2">
                                Room ID
                            </p>
                            <div className="flex items-center gap-2">
                                <p
                                    className="truncate w-[70%]"
                                >
                                    {
                                        requestData?.booked_room_id || "room ID"
                                    }
                                </p>
                            </div>
                        </div>
                                
                        {requestData.time_of_arrival && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">Trip Date</p>
                                <p>{tripDate}</p>
                            </div>
                        }

                        {requestData.time_of_arrival && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">
                                    Requested Time
                                </p>
                                <p>{tripTime}</p>
                            </div>
                        }
                    </div>
                    
                    {/* Location and other details */}
                    <div className="flex items-center">
                        <div className="w-1/3">
                            <p className="text-[#8C9199] mb-2">
                                Pickup Location
                            </p>
                            <p>
                                {requestData?.pick_up_location || ""}
                            </p>
                        </div>
                        <div className="w-1/3">
                            <p className="text-[#8C9199] mb-2">
                                Drop-off Location
                            </p>
                            <p>
                                {requestData?.drop_off_location || ""}
                            </p>
                        </div>
                        <div className="w-1/3">
                            <p className="text-[#8C9199] mb-2">No. of people</p>
                            <p>{requestData?.number_of_people || ""}</p>
                        </div>
                    </div>

                    {/* Fees and other Details */}
                    {requestData?.price && 
                        <div className="flex ">
                            <div className="">
                                <p className="text-[#8C9199]">Fee</p>
                                <div className="flex gap-3 w-full items-center">
                                    <input
                                        type="text"
                                        value={requestData?.price || ""}
                                        placeholder="Enter amount"
                                        className="px-2 py-1.5 rounded-md border-[1.5px]"
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    }

                    <PromoBreakdown
                        grossAmount={requestData?.price}
                        discountAmount={requestData?.discount_amount}
                        promotionId={requestData?.promotion_id}
                    />

                    {/* Driver Details */}
                    <div className="flex">
                        {requestData?.driver_name && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199]">Driver's Name </p>
                                <input
                                    type="text"
                                    value={requestData?.driver_name || ""}
                                    placeholder="Enter driver's name"
                                    className="px-2 py-1.5 border-[1.5px] rounded-md mt-1"
                                    disabled
                                />
                            </div>
                        }

                        {requestData?.driver_contact && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199]">
                                    Driver's Contact{" "}
                                </p>
                                <input
                                    type="tel"
                                    value={requestData?.driver_contact || ""}
                                    placeholder="Enter driver's contact"
                                    className="px-2 py-1.5 border-[1.5px] rounded-md mt-1"
                                    disabled
                                />
                            </div>
                        }

                        {requestData?.vehichle_number  && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199]">Vehicle Number</p>
                                <input
                                    type="text"
                                    value={requestData?.vehichle_number || ""}
                                    placeholder="Enter vehicle number"
                                    className="px-2 py-1.5 border-[1.5px] rounded-md mt-1"
                                    disabled
                                />
                            </div>
                        }

                    </div>

                    
                    {/* Remarks */}
                    {requestData?.remarks && 
                        <div>
                            <p className="text-[#8C9199] mb-1">Remarks</p>
                            <textarea
                                value={requestData?.remarks || ""}
                                rows={4}
                                className="w-full border-[1.5px] rounded-md p-2"
                                placeholder="Please leave your remarks here"
                                disabled
                            ></textarea>
                        </div>
                    }
                </div>
                
            </div>
   

        </div>
    );
};

export default PrePostCabModal;
